<template>
  <v-app>
    <hbt-navbar :endtime="endtime" />
    <router-view class="view" :endtime="endtime" ></router-view>
  </v-app>
</template>

<script>
import HbtNavbar from './components/Navbar';

export default {
  name: 'App',

  components: {
    HbtNavbar,
  },

  data: () => ({
    endtime: 'Aug 20, 2020 18:30:00',
  }),
};
</script>
